export default __webpack_public_path__ + "static/media/CatalogoLocacaoIlhaBela.3bc2410d.pdf";